import { LayoutDashboard, Sparkles } from 'lucide-react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getContextBadgeClasses } from '../../utils/ai/chatTheme';

const ChatContextBar = ({ theme = 'dark' }) => {
  const jira = useSelector((state) => state.jira || {});
  const sprintName = jira.selectedSprintName || jira.Sprint?.name;
  const releaseName = jira.selectedReleaseName || jira.Release?.name;
  const projectName = jira.selectedProjectName;
  const selectedValue = jira.selectedValue || 'sprint';
  const scopeLabel =
    selectedValue === 'release'
      ? releaseName || 'No release selected'
      : sprintName || 'No sprint selected';

  const badges = [
    projectName ? { icon: LayoutDashboard, label: projectName } : null,
    { icon: Sparkles, label: scopeLabel },
  ].filter(Boolean);

  if (!badges.length) {
    return null;
  }

  return (
    <div
      className={`flex flex-wrap items-center gap-2 px-4 py-2 text-xs ${
        theme === 'dark' ? 'bg-[#1B2D42]/60' : 'bg-[#F8FBFE]'
      }`}
    >
      <span className={theme === 'dark' ? 'text-[#8CA0B8]' : 'text-[#6C7A91]'}>Context</span>
      {badges.map((badge) => {
        const Icon = badge.icon;
        return (
          <span
            key={badge.label}
            className={`inline-flex max-w-[200px] items-center gap-1.5 truncate rounded-md px-2 py-1 font-medium ${getContextBadgeClasses(theme)}`}
            title={badge.label}
          >
            <Icon className="h-3.5 w-3.5 shrink-0 opacity-80" />
            <span className="truncate">{badge.label}</span>
          </span>
        );
      })}
    </div>
  );
};

ChatContextBar.propTypes = {
  theme: PropTypes.oneOf(['light', 'dark']),
};
export default ChatContextBar;